export default {
  name: 'root',
  path: '/'
}